require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-drassmarkt.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-drassmarkt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-drassmarkt!./.cache/json/betreuungseinrichtungen-oberpullendorf-drassmarkt.json
// module id = 972
// module chunks = 231608221292675